import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PresentingProblemPanelComponent } from '@features/intervention/presenting-problem/components/presenting-problem-panel/presenting-problem-panel.component';
import { ScaleSliderComponent } from '@shared/components/scale-slider/scale-slider.component';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { PresentingGroup } from '../../cia-form-groups';
import { CiaStepBase } from '../../cia-step-base';

// Step 1, Presenting problem: when the intake was, the coded problem (cluster and problem, recorded on the intervention), the problem as the
// member reports it, and how long, how bad and what came before.
@Component({
  selector: 'cia-step-presenting',
  imports: [ReactiveFormsModule, PresentingProblemPanelComponent, ScaleSliderComponent, ...SharedMaterialUIModule],
  templateUrl: './cia-step-presenting.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class CiaStepPresentingComponent extends CiaStepBase {
  // The step's form group, held by the form so its validity counts there.
  readonly group = input.required<PresentingGroup>();
  // The intervention the assessment is for, whose coded problem is recorded in this step.
  readonly interventionId = input<string | null>(null);
  readonly interventionStatus = input<string | null>(null);
}
